export default __webpack_public_path__ + "static/media/problem.b3e20ec2.svg";